import { useCallback, useState } from 'react';

import { utils as appClientUtils } from '@edf-pkg/app-client';

export const useAccountLock = () => {
    const [accountLockedState, setAccountLockedState] = useState({ showAlert: false, minutesLeftUntilUnlock: 0 });

    const handleLockAccount = useCallback((remainingTimeInSeconds) => {
        const minutesLeft = remainingTimeInSeconds
            ? Math.ceil(remainingTimeInSeconds / 60)
            : appClientUtils.auth.calculateAccountLockedTimeLeftFromLocalStorage();

        setAccountLockedState({ showAlert: true, minutesLeftUntilUnlock: Math.max(minutesLeft, 0) });
        if (minutesLeft <= 0) {
            appClientUtils.auth.removeAccountLockedDataInLocalStorage();
            setAccountLockedState({ showAlert: false, minutesLeftUntilUnlock: 0 });
        }
    }, []);

    const closeAccountLockedAlert = useCallback(() => {
        setAccountLockedState((previousState) => ({ ...previousState, showAlert: false }));
    }, []);

    const resetAccountLockedState = useCallback(() => {
        appClientUtils.auth.removeAccountLockedDataInLocalStorage();
        setAccountLockedState({ showAlert: false, minutesLeftUntilUnlock: 0 });
    }, []);

    return { accountLockedState, handleLockAccount, closeAccountLockedAlert, resetAccountLockedState };
};
